<template>
  <aside
    class="app-sidebar"
    :class="{
      'app-sidebar--collapsed': collapsed,
      'app-sidebar--mobile-open': mobileOpen,
    }"
  >
    <div class="app-sidebar__head">
      <span v-if="!collapsed" class="app-sidebar__brand">VillaOS</span>
      <button
        class="app-sidebar__collapse"
        :title="collapsed ? 'Espandi menu' : 'Comprimi menu'"
        @click="$emit('toggle-collapse')"
      >
        <i
          :class="
            collapsed ? 'fa-solid fa-angles-right' : 'fa-solid fa-angles-left'
          "
        ></i>
      </button>
      <button
        class="app-sidebar__close"
        aria-label="Chiudi menu"
        @click="$emit('close')"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <nav class="app-sidebar__nav">
      <template v-for="item in items" :key="item.to || item.label">
        <!-- Voce navigabile -->
        <router-link
          v-if="!item.disabled"
          :to="item.to"
          class="app-nav-link"
          :title="item.label"
          @click="$emit('close')"
        >
          <span class="app-nav-link__icon"><i :class="item.icon"></i></span>
          <span v-if="!collapsed" class="app-nav-link__label">{{
            item.label
          }}</span>
        </router-link>

        <!-- Voce placeholder (modulo futuro, non ancora attivo) -->
        <span
          v-else
          class="app-nav-link app-nav-link--disabled"
          :title="item.label + ' — in arrivo'"
        >
          <span class="app-nav-link__icon"><i :class="item.icon"></i></span>
          <span v-if="!collapsed" class="app-nav-link__label">
            {{ item.label }}
            <small class="app-nav-link__soon">presto</small>
          </span>
        </span>
      </template>
    </nav>

    <!-- Azioni account/logout: solo mobile (nel menu unico). Su desktop
         restano nella TopBar. (D12A) -->
    <div class="app-sidebar__mobile-actions">
      <router-link
        to="/home/account"
        class="app-nav-link"
        @click="$emit('close')"
      >
        <span class="app-nav-link__icon"><i class="fa-solid fa-user"></i></span>
        <span v-if="!collapsed" class="app-nav-link__label">Account</span>
      </router-link>
      <button class="app-nav-link app-nav-link--btn" @click="logout">
        <span class="app-nav-link__icon">
          <i
            :class="
              loggingOut
                ? 'fa-solid fa-spinner fa-spin'
                : 'fa-solid fa-right-from-bracket'
            "
          ></i>
        </span>
        <span v-if="!collapsed" class="app-nav-link__label">
          {{ loggingOut ? "Uscita…" : "Logout" }}
        </span>
      </button>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from "vuex";
import { setAuth } from "@/router";

export default {
  name: "AppSidebar",
  props: {
    collapsed: { type: Boolean, default: false },
    mobileOpen: { type: Boolean, default: false },
  },
  emits: ["toggle-collapse", "close"],
  data() {
    return { loggingOut: false };
  },
  computed: {
    ...mapGetters([
      "userRole",
      "isAdminUser",
      "canManage",
      "isCareUser",
      "isOperatorRole",
    ]),
    // Navigazione filtrata per ruolo (D10A).
    //  - operator: solo pannello operatore (mobile/placeholder);
    //  - manager: gestione operativa (Strutture, Archivio ospiti), niente
    //    Dashboard globale (economia) né Dati società;
    //  - dev/admin: tutto, incluso Dati società.
    items() {
      if (this.isOperatorRole) {
        return [
          {
            to: "/operator",
            label: "Pannello operatore",
            icon: "fa-solid fa-mobile-screen-button",
          },
        ];
      }

      const list = [];
      if (this.isAdminUser) {
        list.push({
          to: "/home",
          label: "Dashboard",
          icon: "fa-solid fa-gauge-high",
        });
      }
      list.push(
        { to: "/facilities", label: "Strutture", icon: "fa-solid fa-building" },
        { to: "/guests", label: "Archivio ospiti", icon: "fa-solid fa-users" },
        // Pannello operatore accessibile anche a manager/admin/dev (supervisione).
        {
          to: "/operator",
          label: "Pannello operatore",
          icon: "fa-solid fa-mobile-screen-button",
        },
        {
          to: "/home/supplies",
          label: "Magazzino forniture",
          icon: "fa-solid fa-box-open",
        }
      );
      // Review qualità assistenziale (D13) — dev/admin/manager/infermiere.
      if (this.isCareUser) {
        list.push({
          to: "/home/care-review",
          label: "Review assistenziale",
          icon: "fa-solid fa-clipboard-check",
        });
      }
      if (this.isAdminUser) {
        list.push({
          to: "/home/billing",
          label: "Contabilità",
          icon: "fa-solid fa-file-invoice",
        });
        list.push({
          to: "/home/settings",
          label: "Impostazioni",
          icon: "fa-solid fa-gear",
        });
      }
      return list;
    },
  },
  methods: {
    async logout() {
      if (this.loggingOut) return;
      this.loggingOut = true;
      try {
        await this.$axios.post("/auth/logout");
        setAuth(false);
        this.$emit("close");
        await this.$router.push("/login");
        this.$toast.success("Logout effettuato con successo!");
      } catch {
        this.$toast.error("Errore durante il logout");
      } finally {
        this.loggingOut = false;
      }
    },
  },
};
</script>

<style src="@/css/AppLayout.css" />
